import { z } from 'zod';
import { HttpErrorResponse } from '../common/validation-error';
const PositiveId = z.coerce.number().int().positive();
const SuccessResponse = z.object({ success: z.boolean() });
export const saveTeamsProfileRoute = {
    version: 1,
    method: 'POST',
    path: '/teams/profile',
    name: 'save-profile-onboarding',
    request: {
        body: z.object({
            learnerId: PositiveId,
            answers: z.object({
                'ask-name': z.string(),
                'ask-role': z.string(),
                'ask-ideal-teacher': z.array(z.string()),
            }),
        }),
    },
    responses: {
        200: SuccessResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const postCohortOnboardingRoute = {
    version: 1,
    method: 'POST',
    path: '/teams/cohort/onboarding',
    name: 'post-cohort-onboarding',
    request: {
        body: z.object({
            cohortInviteId: PositiveId,
            answers: z.object({
                'ask-notification-time': z.object({
                    timezone: z.string().min(1),
                    time: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/),
                }),
                'ask-office-hours-time': z.array(z.string()),
                'ask-comments': z.string(),
            }),
        }),
    },
    responses: {
        200: SuccessResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const requestMentorReviewRoute = {
    version: 1,
    method: 'POST',
    path: '/teams/activity/request-review',
    name: 'request-mentor-review',
    request: {
        body: z.object({
            questionId: PositiveId,
            isRequestingReview: z.boolean(),
            sessionId: PositiveId,
            type: z.enum(['ACTIVITY', 'PROJECT']),
            comment: z.string(),
        }),
    },
    responses: { 200: SuccessResponse, 400: HttpErrorResponse },
};
export const createTeamsProjectAIReviewRoute = {
    version: 1,
    method: 'POST',
    path: '/teams/{companySlug}/projects/{projectSlug}/aireview',
    name: 'create-teams-project-ai-review',
    request: {
        params: z.object({
            companySlug: z.string().min(1),
            projectSlug: z.string().min(1),
        }),
        body: z.object({ sessionId: PositiveId, projectSlug: z.string().min(1) }),
    },
    responses: {
        200: z.string(),
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
